import { useContainerDimensions } from '@euler/functions/useAdaptiveContainerWidth';
import { DeliveryCheckSceneType } from '@euler/model/enum';
import { VehicleReport } from '@euler/model/report';
import { memo } from 'react';
import { FlatList, ScrollViewProps } from 'react-native';
import { useDeliveryCheckReportModels } from '../../functions/useDeliveryCheckReportModels';
import { DeliveryCheckCell } from './DeliveryCheckCell';

export const DeliveryCheckReportView = memo(
  ({
    report,
    sceneType,
    ...scrollViewProps
  }: {
    report: VehicleReport;
    sceneType: DeliveryCheckSceneType;
  } & ScrollViewProps) => {
    const { cells } = useDeliveryCheckReportModels(report, sceneType);
    const { width } = useContainerDimensions();
    return (
      <FlatList
        {...scrollViewProps}
        data={cells}
        keyExtractor={x => String(x.index)}
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        renderItem={({ item }) => (
          <DeliveryCheckCell model={item} width={width} />
        )}
      />
    );
  },
);
